import React, { useEffect, useState } from "react";
import "../css/wb_template.css";
import { Link } from "react-router-dom";
import Eye from "../Assets/images/eye.png";
import Delete from "../Assets/images/delete.png";
import charts from "../Assets/images/charts.png";
import Plus from "../Assets/images/plus.png";
import { apiCall } from '../services/authServieces';
import ShowSnackBar from "../components/snackBar";
import AlertDialog from '../components/deleteComponent';
import { deleteTemplate,HandleSyncTemplate } from '../services/templateService';
import PdfIcon from '../Assets/images/pdf.png';
import TablePagination from '@mui/material/TablePagination';
import { ClipLoader } from "react-spinners";
import { useUIContext } from "../context/index";

import excelIcon from "../Assets/images/excel.png"

const WbTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [isTemplate, setIsTemplate] = useState([]);
  const [snackBar, setSnackBar] = useState({ open: false, severity: '', message: '' });
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [page, setPage] = useState(0); // Pagination: current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Pagination: rows per page
  const [totalTemplates, setTotalTemplates] = useState(0); // Total number of templates
  const { userType } = useUIContext();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("WhatsApp");

  const [searchTerm, setSearchTerm] = useState("");

  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);



  const options = ["WhatsApp", "SMS"];

  console.log(userType, " got my user type")

  const handleClickOpen = (templateName, templateId) => {
    setSelectedTemplateName(templateName);
    setSelectedTemplateId(templateId);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSync = async (templateId) => {
    setLoading(true);
    try {
      const res = await HandleSyncTemplate({ payload: templateId });

      console.log(res.success,"res")
      console.log(res,"res")
      if (res.success) {
        setSnackBar({
          open: true,
          severity: true,
          message: res.message,
        });

  
          // Re-fetch data to ensure updated state for pagination
          fetchTemplates();
      
      }
    } catch (err) {
      setSnackBar({
        open: true,
        severity: false,
        message: err?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
    setOpenDialog(false);
  };



  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);





  const fetchTemplates = async () => {
    setLoading(true);
    try {
      let res = ""
      if (debouncedSearchTerm) {
        res = await apiCall({
          endpoint: `api/dealers/get-templates-pagination?page=${page + 1}&limit=${rowsPerPage}&search=${debouncedSearchTerm}`,
          method: 'GET',
        });
      } else {

        res = await apiCall({
          endpoint: `api/dealers/get-templates-pagination?page=${page + 1}&limit=${rowsPerPage}`,
          method: 'GET',
        });
      }


      console.log(res, "resuef");

      if (res?.success && res?.data) {
        console.log('res?.data: ', res?.data);

        const formattedData = res.data.map(item => {
          const date = new Date(item.date_time);
          const formattedDate = date.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });

          return {
            ...item,
            date_time: formattedDate,
          };
        });
        setIsTemplate(formattedData || []);
        setTotalTemplates(res.totalCount);
      }

      else {
        setIsTemplate([]);
        setTotalTemplates(0);
      }
    } catch (error) {
      console.log(error, ' got my error')
      setSnackBar({
        open: true,
        severity: false,
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, [page, rowsPerPage, debouncedSearchTerm]); // Re-fetch data on page or rowsPerPage change

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page to 0 when rows per page changes
  };

  const handleCloseSnackBar = () => {
    setSnackBar((prevState) => ({ ...prevState, open: false }));
  };

  const handlePreview = (template) => {
    setSelectedTemplate(template); // Set the selected template for the modal
  };





  const handleDownload = async () => {
    if (selected == "SMS") {

      handleDownloadSMS()

    } else {
      handleDownloadWhatsapp()
    }
  }



  const handleDownloadWhatsapp = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user-cred"));
      const token = user?.token;
      const baseURL = process.env?.REACT_APP_API_URL;

      const apiUrl = `${baseURL}/api/dealers/download-get-templates`;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();

      let filename = "Template_Report.csv";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackBar({
        open: true,
        severity: true,
        message: "CSV File Downloaded Successfully",
      });
    } catch (error) {
      console.error("Download error:", error);
      setSnackBar({
        open: true,
        severity: false,
        message: "Failed to download CSV file",
      });
    } finally {
      setLoading(false);
    }
  };



  const handleDownloadSMS = async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user-cred"));
      const token = user?.token;
      const baseURL = process.env?.REACT_APP_API_URL;

      const apiUrl = `${baseURL}/api/dealers/download-sms-templates`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();

      let filename = 'SMS_Templates.csv';
      const disposition = response.headers.get('Content-Disposition');
      if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSnackBar({
        open: true,
        severity: "success",
        message: "SMS CSV File Downloaded Successfully",
      });
    } catch (error) {
      console.error('Download error:', error);
      setSnackBar({
        open: true,
        severity: "error",
        message: "Failed to download SMS CSV file",
      });
    } finally {
      setLoading(false);
    }
  };





  const handleChangeDropdown = async (option) => {
    try {

      if (!option) {
        alert("Please Select Any Option")
        return;
      }
      setSelected(option)


      if (option == 'SMS') {

        try {
          setLoading(true);
          let response = await apiCall({
            endpoint: `api/dealers/get-templates-sms-pagination?page=${page + 1}&limit=${rowsPerPage}`,
            method: "POST",
            payload: { selected: selected }
          })

          if (response.success) {

            if (response.data) {


              const formattedData = response.data.map(item => {
                const date = new Date(item.date_time);
                const formattedDate = date.toLocaleString('en-GB', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                });

                return {
                  ...item,
                  date_time: formattedDate,
                };
              });
              setIsTemplate(formattedData || []);
              setTotalTemplates(res.totalCount);

            } else {
              setIsTemplate([]);
              setTotalTemplates(0);
            }
          }
          else {
            console.log("not fetch data proper");
          }
        } catch (error) {
          console.log('error: in fitch data proper  ', error);

        } finally {
          setLoading(false);
        }
      } else {
        fetchTemplates()
      }
    } catch (error) {
      console.log('error: ', error);

    }
  }


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };


  return (
    <>
      <div className="Template_id_contian1">
        <h4 className="Head_titleTemplate_1">
          {/* <div className="dropdown-1">
        

        
              <div className="dropdown-content">
              <select
  className="dropdown-select"
  value={selected}   
  onChange={(e) => {
    handleChangeDropdown(e.target.value);
    setOpen(false);
  }}
>
  {options.map((option, i) => (
    <option key={i} value={option}>
      {option}
    </option>
  ))}
</select>


              </div>
           
          </div> */}


          {userType !== "admin" && userType !== "superadmin" && (
            <div className="dropdown-1">
              <div className="dropdown-content">
                <select
                  className="dropdown-select"
                  value={selected}
                  onChange={(e) => {
                    handleChangeDropdown(e.target.value);
                    setOpen(false);
                  }}
                >
                  {options.map((option, i) => (
                    <option key={i} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}









          My Templates
          <div className="Session_report_SearchContain search_btn_in new_div">
            <div className="dev_box">
              <input
                placeholder="Search"
                type="text"
                className="templateSearchInput"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <button type="button" className="new_bottom" onClick={handleDownload}>
                <img src={excelIcon} alt="excelIcon" className="ExcelIcon" />
              </button>
              {userType === "super_admin" && (<Link className="add_btn1 add_btn33 text-nowrap WMadd_btntemp1" to="/wbaddtemplate">
            <img src={Plus} alt="img" /> Add Template
          </Link>)}
            </div>


          </div>

          
        </h4>
        <div className="Template_id_Card1">
          <div className="table_contain" id="tableContain">
            <table className="Table" id="Table">
              <thead>
                <tr>
                  {userType === "super_admin" && (
                    <th>Admin Id</th>
                  )}
                  {/* <th>Template ID</th> */}
                  <th>Template Name</th>
                  <th>Template Type</th>
                  <th>Preview</th>
                  <th>Category</th>
                  <th>Language</th>
                  <th>Date/Time</th>
                  <th>Status</th>

                {userType === "super_admin" && selected!='SMS' && (
                  <th>Action</th>
                )}
        
                </tr>
              </thead>
              <tbody>
                {isTemplate.length > 0 ? (
                  isTemplate.map((template, index) => (
                    <tr key={"Template" + index}>
                      {/* <td>{index + 1}</td> */}
                      {userType === "super_admin" && (
                        <td>{selected === "SMS" ? template.admin_id : template.adminName}</td>
                      )}
                      {/* <td>{template.temp_id}</td> */}
                      <td>{selected === "SMS" ? template.templatename : template.temp_name}</td>
                      <td>{selected === 'SMS' ? template.template_type : template.t_type}</td>


                      <td>

                        <button
                          className="download_icon"
                          onClick={() => handlePreview(template)} // Pass template data to modal
                          data-bs-toggle="modal"
                          data-bs-target="#Preview_modal"
                        >
                          <img src={Eye} alt="preview" />
                        </button>
                        {selected !== "SMS" ? (
                          userType === "client" && (
                            <Link to={`/wbtemplate-details?tempid=${template.temp_id}&tempname=${template.temp_name}`}>
                              <button className="del_btn_graph graph_btn" title="View Template Insight">
                                <img src={charts} alt="delete" />
                              </button>
                            </Link>
                          )
                        ) : null}



                      </td>
                      <td>{selected === "SMS" ? "-" : template.cat}</td>
                      <td>{selected === "SMS" ? "-" : template.lang}</td>
                      <td>{template.date}, {template.time}</td>
                      <td>
                        {['ACCEPTED', 'REJECTED', 'PENDING', 'APPROVED', 'Approved'].includes(selected === "SMS" ? template.description : template.status) && (
                          <span className={selected === "SMS" ? template.description : template.status.toLowerCase()}>
                            {selected === "SMS" ? template.description : template.status}
                          </span>
                        )}
                      </td>

                       {userType === "super_admin" && selected!='SMS' && (
                  <td>
                     <button className="del_btn1" onClick={() => handleClickOpen(template.temp_name, template.temp_id)}>
                    Sync
                    </button>

                  </td> 
                )}
                  
                      {/* <td>
                        <button className="del_btn1" onClick={() => handleClickOpen(template.temp_name, template.temp_id)}>
                          <img src={Delete} alt="delete" />
                        </button>

                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">No Templates Found</td>
                  </tr>
                )}
              </tbody>
            </table>

            <AlertDialog
              open={openDialog}
              onClose={handleClose}
              templateName={selectedTemplateName}
              handleSync={() => handleSync(selectedTemplateId)}
            />
          </div>

          {/* Table Pagination */}
          <TablePagination
            component="div"
            count={totalTemplates}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]} // Define rows per page options
          />
        </div>
      </div>

      {/* Modal for Template Preview */}
      <div className="modal fade" id="Preview_modal" tabIndex="-1" aria-labelledby="Preview_modal_Label" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content p-0">
            <div className="modal-header">
              <h5 className="modal-title" id="Preview_modal_Label">
                Template Preview
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body ">
              {selectedTemplate ? (
                <div className="Modal_Table_contain">
                  <div className="templateContainer">
                    <div
                      style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '10px',
                        width: '100%',
                      }}
                    >
                      {selectedTemplate.t_type === 'Media' && selectedTemplate.media_type === 'Document' && (
                        <div
                          className="templateHeader d-flex justify-content-center align-items-center"
                          style={{
                            backgroundImage: 'url(../Assets/images/whatsappBG.jpg)',
                            maxheight: '300px',
                            flexDirection: 'column',
                            margin: 'auto',
                            borderRadius: '5px',
                            backgroundColor: '#f5f5f5',
                          }}
                        >
                          <img src={PdfIcon} alt="pdf img" height={50} width={100} />
                          <a href={`${selectedTemplate.file_doc}`} target="_blank">
                            View Document
                          </a>
                        </div>
                      )}

                      {selectedTemplate.t_type === 'Media' && selectedTemplate.media_type === 'Image' && (
                        <div
                          className="templateHeader d-flex justify-content-center align-items-center"
                          style={{
                            backgroundImage: 'url(../Assets/images/whatsappBG.jpg)',
                            maxheight: '300px',
                            flexDirection: 'column',
                            margin: 'auto',
                            borderRadius: '5px',
                            backgroundColor: '#f5f5f5',
                          }}
                        >
                          <img src={`${selectedTemplate.file_img}`} alt="image preview" style={{ height: 'inherit', width: '100%', borderRadius: '10px' }} />
                        </div>
                      )}

                      {selectedTemplate.t_type === 'Media' && selectedTemplate.media_type === 'Video' && (
                        <div
                          className="templateHeader d-flex justify-content-center align-items-center"
                          style={{
                            backgroundImage: 'url(../Assets/images/whatsappBG.jpg)',
                            maxheight: '300px',
                            flexDirection: 'column',
                            margin: 'auto',
                            borderRadius: '5px',
                            backgroundColor: '#f5f5f5',
                          }}
                        >
                          <video autoPlay className="uploaded-video viewMedia">
                            <source src={`${selectedTemplate.file_video}`} />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      )}

                      <p className="mt-3 mb-0">{selectedTemplate.message}</p>

                      {selectedTemplate.f_text && <p className="mb-0">{selectedTemplate.f_text}</p>}
                    </div>

                    <div className="showButtons d-flex align-items-center mt-3" style={{ flexDirection: 'column' }}>
                      {selectedTemplate.UrlBtnText1 && (
                        <button className="btn btn-primary mb-2">{selectedTemplate.UrlBtnText1}</button>
                      )}

                      {selectedTemplate.UrlBtnText2 && (
                        <button className="btn btn-primary mb-2">{selectedTemplate.UrlBtnText2}</button>
                      )}

                      {selectedTemplate.phone_text1 && (
                        <button className="btn btn-primary mb-2">{selectedTemplate.phone_text1}</button>
                      )}

                      {/* Render quick replies dynamically */}
                      {[...Array(10)].map((_, index) => {
                        const quickReplyKey = `quickReply${index + 1}`;
                        return (
                          selectedTemplate[quickReplyKey] && (
                            <button key={quickReplyKey} className="btn btn-primary mb-2">
                              {selectedTemplate[quickReplyKey]}
                            </button>
                          )
                        );
                      })}
                    </div>
                  </div>
                </div>
              ) : (
                <p>No template selected</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Snackbar for feedback messages */}
      <ShowSnackBar
        open={snackBar.open}
        severity={snackBar.severity}
        message={snackBar.message}
        onClose={handleCloseSnackBar}
      />

      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}

    </>
  );
};

export default WbTemplate;
